import LaunchCastingMeetingTab from "./sub_tabs/LaunchCastingMeetingTab";

const castingMeetingTabRouter = {

  launch: 
  {
    title: 'Launch',
    element: <LaunchCastingMeetingTab />
  },

}

export default castingMeetingTabRouter;